<div class="e-checkbox-tree" [class.e-checkbox-tree-accordion-style]="accordionStyle">
    <div *ngFor="let branch of treeBranches">
        <ul role="tree">
            <ng-template #treeNode let-branch>
                <li *ngFor="let node of branch; let i = index">
                    <div
                        class="e-node-wrapper"
                        role="treeitem"
                        #treeNodeRef
                        [class.e-parent]="hasChildren(node)"
                        [class.e-node-disabled]="node.state === 'disabled'"
                        [attr.data-node-id]="getNodeId(node)"
                        [tabindex]="!node.parentId && i === 0 ? 0 : -1"
                        [attr.aria-expanded]="hasChildren(node) ? node.isExpanded : null"
                        [attr.aria-owns]="hasChildren(node) ? 'group-' + getNodeId(node) : null"
                        (keydown)="keyEvents($event, node)">
                        <button
                            *ngIf="hasChildren(node)"
                            (click)="toggleTreeNode(node)"
                            class="e-node-expander"
                            [class.e-node-expanded]="node.isExpanded"
                            tabindex="-1"
                            aria-label="Expand or collapse tree node"></button>
                        <label class="e-node-content">
                            <input
                                type="checkbox"
                                (change)="selectionChanged(node)"
                                [disabled]="node.state === 'disabled'"
                                [checked]="node.state === 'checked'"
                                [indeterminate]="node.state === 'indeterminate'"
                                tabindex="-1"
                                [attr.aria-checked]="node.state === 'checked' ? 'true' : 'false'" />
                            <span class="e-checkbox" aria-hidden="true"></span>
                            <span class="e-node-label" [class.e-extra-padding]="node.count">{{ node.label }}</span>
                            <span class="e-total-count" *ngIf="node.count">({{ node.count }})</span>
                        </label>
                    </div>
                    <ul *ngIf="hasChildren(node) && node.isExpanded" class="e-node-children" role="group" [id]="'group-' + getNodeId(node)">
                        <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: node.children }"></ng-container>
                    </ul>
                </li>
            </ng-template>
            <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: branch }"></ng-container>
        </ul>
    </div>
</div>
